import React, { useCallback, useEffect, useState } from "react";
import api from "utils/apiService";

import TableDemo from "components/TableDemo";
import { AdminNotificationsColumn } from "data/NotificationsColumns";
import { useSearchParams } from "react-router-dom";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [notifications, setNotifications] = useState({
    data: [],
    pagination: { totalDocs: 0 },
  });
  const [notificationLoading, setNotificationLoading] = useState(true);
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/notifications/getAllNotificationsSentByAdmin?page=${page}`
      );

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);

  const fetchNotifications = useCallback(async () => {
    setNotificationLoading(true);
    try {
      const res = await api.get(`/notifications?page=${page}`);

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setNotifications({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setNotificationLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData();
    fetchNotifications();
  }, [fetchData, fetchNotifications]);

  return (
    <section className="mt-3">
      <div className="mb-10">
        <TableDemo
          data={notifications?.data}
          columns={AdminNotificationsColumn}
          title="الإشعارات"
          totalCount={notifications?.pagination?.totalDocs}
          loading={notificationLoading}
        />
      </div>

      <div className="mb-6">
        <TableDemo
          data={data?.data}
          columns={AdminNotificationsColumn}
          title="إشعارات من الإدارة"
          totalCount={data?.pagination?.totalDocs}
          loading={loading}
        />
      </div>
    </section>
  );
};

export default Index;
